/**
 * Returns the currently single-selected table element.
 */
export const getSelectedTableElement = (): HTMLDivElement | null =>
    document.querySelector<HTMLDivElement>('.Table.selected-single');

/**
 * Queries an element within the currently single-selected table.
 */
export const querySelectedTableDOMElement = <T extends Element>(selectors: string): T | null =>
    getSelectedTableElement()?.querySelector<T>(selectors) || null;

/**
 * Returns the active current cell element within the supplied or selected table.
 */
export const getCurrentCellDOMElement = (tableDomElement?: HTMLElement): HTMLDivElement | null =>
    (tableDomElement || getSelectedTableElement())?.querySelector('.current') || null;
